<template>
  <div class="chatbot-container">
    <BotChatList/>
    <BotChatForm/>
  </div>
</template>

<script>

import {defineComponent} from "vue";
import BotChatList from "@/components/Room/ChatBot/BotChatList.vue";
import BotChatForm from "@/components/Room/ChatBot/BotChatForm.vue";

export default defineComponent({
  name: 'ChatBot',
  components: {BotChatForm, BotChatList}
})
</script>

<style lang="scss" scoped>
.chatbot-container {
  background-color: white;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>